export function isLocalhost() {
  if (typeof window === 'undefined') return false;

  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
}

export function isLocalAdminEnabled() {
  return process.env.NODE_ENV === 'development' && isLocalhost();
}
